import useGlobalData from '@hooks/useGlobalData';
import tw, { css, styled } from 'twin.macro';
import CommunityIcon from '../../static/images/community.svg';
import TwitterIcon from '../../static/images/twitter.svg';
import ProductNewsIcon from '../../static/images/newspaper.svg';

const MenuFooterWrapper = styled.div`
  ${tw`mb-[10px]`}
  ${tw`border-t-grey border-t-[1px]`}
  ${tw`mx-auto`}
  ${tw`pt-[10px]`}
  ${tw`text-[1.2rem]`}
  ${tw`flex`}
`;

const FooterItem = styled.a`
  ${tw`flex justify-between`}
  ${tw`p-[8px]`}
  ${tw`rounded-[3px]`}
  ${css`
    figure {
      svg {
        ${tw`w-[16px] h-[16px]`}
      }
    }
    :hover {
      ${tw`bg-menu-hover`}
    }
  `}
`;

const FooterItemLabel = styled.span`
  ${tw`px-[4px]`}
`;

const MenuFooter: React.FC = () => {
  const { menuFooterUrls } = useGlobalData();
  return (
    <MenuFooterWrapper>
      {menuFooterUrls.website && (
        <FooterItem href={menuFooterUrls.website} title="SonarQube">
          <FooterItemLabel>SonarQube</FooterItemLabel>
        </FooterItem>
      )}
      <FooterItem href="https://www.sonarsource.com/solutions/clean-code" title="Clean Code">
        <FooterItemLabel>Clean Code</FooterItemLabel>
      </FooterItem>
      {menuFooterUrls.community && (
        <FooterItem href={menuFooterUrls.community} title="Community">
          <figure>
            <CommunityIcon />
          </figure>
        </FooterItem>
      )}
      {menuFooterUrls.social && (
        <FooterItem href={menuFooterUrls.social} rel="noreferrer" target="_blank" title="Twitter">
          <figure>
            <TwitterIcon />
          </figure>
        </FooterItem>
      )}
      {menuFooterUrls.productNews && (
        <FooterItem href={menuFooterUrls.productNews} title="Product News">
          <figure>
            <ProductNewsIcon />
          </figure>
        </FooterItem>
      )}
    </MenuFooterWrapper>
  );
};

export default MenuFooter;
